import React from "react";
import { Box, CircularProgress } from "@mui/material";

export const Loading = ({ marginTop = 0, marginBottom = 0 }: { marginTop?: number; marginBottom?: number }) => (
  <Box data-testid="loading" marginTop={marginTop} marginBottom={marginBottom} display="flex" justifyContent="center">
    <CircularProgress data-testid="circularProgress" sx={{ color: "primary.main" }} size={44} thickness={3} />
  </Box>
);
